import { useQuery, UseQueryOptions } from 'react-query';

import type { Playlist } from '@24i/nxg-sdk-photon';
import { usePurchaseData } from '@24i/nxg-sdk-smartott-shared/src/context/PurchaseData';

import { queryKeys } from '../queryKeys';

const useMyExpiredRentalsQuery = (options?: UseQueryOptions<Playlist>) => {
    const { fetchMyExpiredRentals } = usePurchaseData();

    return useQuery<Playlist>(queryKeys.myExpiredRentals(), fetchMyExpiredRentals, {
        ...options,
    });
};

export default useMyExpiredRentalsQuery;
